class AnalyticsService {
  constructor() {
    this.isInitialized = false;
    this.measurementId = 'G-BWKPJS8D6J';
    this.hasConsent = false;
  }

  setConsent(hasConsent) {
    this.hasConsent = hasConsent;
    if (hasConsent && !this.isInitialized) {
      this.init();
    } else if (!hasConsent && this.isInitialized) {
      this.disable();
    }
  }

  init() {
    if (this.isInitialized || !this.hasConsent) return;

    // Google Analytics Script laden
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.measurementId}`;
    document.head.appendChild(script);

    // Global gtag definieren
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', this.measurementId, {
      send_page_view: true,
      transport_url: 'https://www.google-analytics.com',
      transport_type: 'beacon',
      allow_google_signals: true,
      allow_ad_personalization_signals: true
    });

    this.isInitialized = true;
  }

  disable() {
    if (!this.isInitialized) return;
    
    // GA4 deaktivieren
    window[`ga-disable-${this.measurementId}`] = true;
    
    // Script-Tag entfernen
    const scriptTag = document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`);
    if (scriptTag) {
      scriptTag.remove();
    }
    
    // Globale Variablen zurücksetzen
    window.dataLayer = undefined;
    window.gtag = undefined;
    
    this.isInitialized = false;
  }

  // Seitenaufrufe tracken
  trackPageView(path, title) {
    if (!this.isInitialized || !this.hasConsent) return;
    
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title,
      page_location: window.location.href
    });
  }

  // Benutzerinteraktionen tracken
  trackEvent(category, action, label = null, value = null) {
    if (!this.isInitialized || !this.hasConsent) return;

    const eventParams = {
      event_category: category,
      event_label: label,
      value: value
    };

    window.gtag('event', action, eventParams);
  }

  // Funnel-Schritte tracken
  trackFunnelStep(funnelType, stepNumber, stepName) {
    if (!this.isInitialized || !this.hasConsent) return;

    window.gtag('event', 'funnel_progress', {
      funnel_type: funnelType,
      step_number: stepNumber,
      step_name: stepName
    });
  }

  // Formular-Übermittlungen tracken
  trackFormSubmission(formName, success = true) {
    if (!this.isInitialized || !this.hasConsent) return;

    window.gtag('event', 'form_submission', {
      form_name: formName,
      success: success
    });
  }

  // Downloads tracken
  trackDownload(fileName, fileType) {
    if (!this.isInitialized || !this.hasConsent) return;

    window.gtag('event', 'download', {
      file_name: fileName,
      file_type: fileType
    });
  }

  // Externe Links tracken
  trackExternalLink(url, linkText) {
    if (!this.isInitialized || !this.hasConsent) return;

    window.gtag('event', 'external_link_click', {
      link_url: url,
      link_text: linkText
    });
  }

  // Scroll-Tiefe tracken
  trackScrollDepth(depth) {
    if (!this.isInitialized || !this.hasConsent) return;

    window.gtag('event', 'scroll_depth', {
      depth_percentage: depth
    });
  }

  // Benutzer-Engagement tracken
  trackEngagement(timeOnPage) {
    if (!this.isInitialized || !this.hasConsent) return;

    window.gtag('event', 'user_engagement', {
      time_on_page: timeOnPage
    });
  }

  // Fehler tracken
  trackError(errorType, errorMessage) {
    if (!this.isInitialized || !this.hasConsent) return;

    window.gtag('event', 'error', {
      error_type: errorType,
      error_message: errorMessage
    });
  }
}

export default new AnalyticsService(); 